<script lang="ts" setup>
const props = defineProps<{
  title: string;
}>();
</script>
<template>
  <div class="flex justify-center items-center pt-10">
    <div class="flex flex-col justify-between items-center gap-10">
      <LogoIcon class="w-48 text-current opacity-30" />
      <p class="text-center text">
        {{ props.title }}
      </p>
    </div>
  </div>
</template>
